<template>
    <div>
      <div v-if="isGroup">
        <public-title>门店购买记录</public-title>
        <div class="load-area">
            <gcon-search @getSearchCon="getSearchCon" />
            <p v-if="StoreLists.total<=0">当前没有数据</p>
            <div v-else>
            <ul class="list-head"><li class="w-50" v-for="item in titleArr" :key="item">{{item}}</li></ul>
            <ul class="list-item" v-for="Itemize in StoreLists.lists" :key="Itemize.id">
                <li class="w-50 list-item-col">
                    <span class="text-link" @click="goStoreDetail(Itemize.store_id)">{{Itemize.title}}</span>
                </li>
                <li class="w-50 list-item-col" v-if="storeInfo.type != 6">{{Itemize.order_ticket_nums}}</li>
                <li class="w-50 list-item-col">{{Itemize.order_product_nums}}</li>
                <li class="w-50 list-item-col" :class="[Itemize.verify === 1 ? 'text-success' : 'text-danger']">
                    {{Itemize.verify | formatVar('verifyType')}}
                </li>
                <li class="w-50 list-item-col">
                    {{Itemize.province_name}}-{{Itemize.city_name}}-{{Itemize.district_name}}
                </li>
                <li class="w-50 list-item-col-end">
                    <span class="text-link" @click="goForDetail(Itemize)">查看</span>
                </li>
            </ul>
            <el-pagination background layout="prev, pager, next" class="mt-4"
                :total="StoreLists.total" :current-page="Number(queryCon.page)"
                @current-change="v => this.$router.push({name:this.$route.name,query:{page:v}})"/>
            </div>
        </div>
      </div>
      <buy-records-index v-else/>
    </div>
</template>

<script>
  import { mapGetters,mapState, mapActions } from 'vuex'
  import BuyRecordsIndex from './BuyRecordsIndex'
  import GconSearch from '../GconSearch'

  export default {
    name: 'BuyRecordsManage',
    components: { BuyRecordsIndex,GconSearch },
    data () {
        return {
            titleArr: ['门店名称','门票数量','度假产品数量','门店认证','所在地','操作'],
            lists: [],
            info: {}
        }
    },
    watch:{
      queryCon() { this.groupGetStoreLists({ page:this.queryCon.page, type:13,...this.info }) },
    },
    created () {
        if (this.isGroup) {
            if (this.storeInfo.type == 6) this.titleArr = ['门店名称','度假产品数量','门店认证','所在地','操作']
            if (this.queryCon.hasOwnProperty('page')) this.groupGetStoreLists({ page:this.queryCon.page, type:13 })
            else this.groupGetStoreLists({ page:1, type:13 })
        }
    },
    computed: {
        ...mapState(['StoreLists']),
        ...mapGetters(['storeInfo','isGroup']),
        queryCon() { return this.$route.query }
    },
    methods: {
        ...mapActions(['groupGetStoreLists']),
        goForDetail (item) {
            this.$router.push({name:'BuyRecords',query:{storeId: item.store_id,GST:item.title}})
        },
        goStoreDetail(id) {
            let routeUrl = this.$router.resolve({name:'StoreDetail',query:{type:this.storeInfo.type,id}});
            window.open(routeUrl.href, '_blank');
        },
        getSearchCon (info) {
            this.info=info;
            this.groupGetStoreLists({ page:1, type:13, ...info })
        }
    }
  }
</script>